export default "__VITE_ASSET__FsGJ9s1y__"